import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import TaxMappingContMain from "presentation/view/container/TaxMapping/TaxMappingContMain";

CommonEntrypoint(<TaxMappingContMain/>)